import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'were_withholdings_from_wages_other_than_social_security'

export const dataPointDefinition = {
  retracedId: 'were_withholdings_from_wages_other_than_social_security',
  name: 'Were withholdings from wages, other than social security, calculated correctly and in line with legal requirements?',
  description:
    'The intent of this question is to understand if the facility made all legally required withholdings (those that are mandatory/involuntary) from wages (e.g. for taxes) in a way that was accurately calculated. Social security deductions are covered separately.',
  meta: {
    slcpMeta: {
      key: 'wb-wag-47',
      number: 'WB-WAGE-119',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wag-47', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35670,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
